import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import VideoCall from './components/VideoCall';
import Privacy from './components/Privacy';
import EarnMoney from './components/EarnMoney';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [page, setPage] = useState('home');

  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (['privacy-policy', 'refund-policy', 'terms'].includes(hash)) {
        setPage(hash);
        window.scrollTo(0, 0);
      } else {
        setPage('home');
      }
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);

  const renderPage = () => {
    switch (page) {
      case 'privacy-policy': return <PrivacyPolicy />;
      case 'refund-policy': return <RefundPolicy />;
      case 'terms': return <TermsConditions />;
      default:
        return (
          <>
            <Hero />
            <Features />
            <VideoCall />
            <Privacy />
            <EarnMoney />
            <About />
            <Contact />
          </>
        );
    }
  };

  return (
    <div className="app">
      <Navbar mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
      {renderPage()}
      <Footer />
    </div>
  );
}

export default App;
